export const crimeaCities = [
  'Алушта',
  'Бондаренково',
  'Верхняя Кутузовка',
  'Виноградное',
  'Генеральское',
  'Запрудное',
  'Зеленогорье',
  'Изобильное',
  'Кипарисное',
  'Лаванда',
  'Лавровое',
  'Лазурное',
  'Лучистое',
  'Малореченское',
  'Малый Маяк',
  'Нижнее Запрудное',
  'Нижняя Кутузовка',
  'Партенит',
  'Приветное',
  'Пушкино',
  'Розовый',
  'Рыбачье',
  'Семидворье',
  'Солнечногорское',
  'Утёс',
  'Чайка',
  'Волошино',
  'Перекоп',
  'Суворово',
  'Джанкой',
  'Евпатория',
  'Заозёрное',
  'Мирный',
  'Новоозёрное',
  'Керчь',
  'Красноперекопск',
  'Саки',
  'Аграрное',
  'Аэрофлотский',
  'Битумное',
  'Грэсовский',
  'Комсомольское',
  'Симферополь',
  'Богатовка',
  'Весёлое',
  'Ворон',
  'Громовка',
  'Грушевка',
  'Дачное',
  'Лесное',
  'Междуречье',
  'Миндальное',
  'Морское',
  'Новый Свет',
  'Переваловка',
  'Прибрежное',
  'Солнечная Долина',
  'Судак',
  'Холодовка',
  'Береговое',
  'Ближнее',
  'Виноградное',
  'Коктебель',
  'Краснокаменка',
  'Курортное',
  'Наниково',
  'Насыпное',
  'Орджоникидзе',
  'Пионерское',
  'Подгорное',
  'Приморский',
  'Солнечное',
  'Степное',
  'Узловое',
  'Феодосия',
  'Щебетовка',
  'Южное',
  'Алупка',
  'Береговое',
  'Виноградное',
  'Восход',
  'Высокогорное',
  'Гаспра',
  'Голубой Залив',
  'Горное',
  'Гурзуф',
  'Даниловка',
  'Кацивели',
  'Кореиз',
  'Краснокаменка',
  'Куйбышево',
  'Курпаты',
  'Ливадия',
  'Линейное',
  'Массандра',
  'Никита',
  'Олива',
  'Оползневое',
  'Ореанда',
  'Отрадное',
  'Охотничье',
  'Парковое',
  'Партизанское',
  'Понизовка',
  'Санаторное',
  'Симеиз',
  'Советское',
  'Форос',
  'Ялта',
  'Айвовое',
  'Аромат',
  'Ароматное',
  'Бахчисарай',
  'Баштановка',
  'Белокаменное',
  'Береговое',
  'Богатое Ущелье',
  'Богатырь',
  'Большое Садовое',
  'Брянское',
  'Верхоречье',
  'Викторовка',
  'Вилино',
  'Высокое',
  'Глубокий Яр',
  'Голубинка',
  'Горка',
  'Дачное',
  'Долинное',
  'Дорожное',
  'Дубровка',
  'Железнодорожное',
  'Заветное',
  'Залесное',
  'Зелёное',
  'Зубакино',
  'Казанки',
  'Каштаны',
  'Кочергино',
  'Красная Заря',
  'Красный Мак',
  'Кудрино',
  'Куйбышево',
  'Малиновка',
  'Маловидное',
  'Малое Садовое',
  'Машино',
  'Многоречье',
  'Мостовое',
  'Нагорное',
  'Научный',
  'Некрасовка',
  'Нижняя Голубинка',
  'Новенькое',
  'Нововасильевка',
  'Новопавловка',
  'Новополье',
  'Новоульяновка',
  'Отрадное',
  'Песчаное',
  'Плодовое',
  'Плотинное',
  'Поляна',
  'Почтовое',
  'Приятное Свидание',
  'Прохладное',
  'Путиловка',
  'Предущельное',
  'Рассадное',
  'Растущее',
  'Репино',
  'Речное',
  'Розовое',
  'Самохвалово',
  'Севастьяновка',
  'Синапное',
  'Сирень',
  'Скалистое',
  'Соколиное',
  'Солнечноселье',
  'Стальное',
  'Суворово',
  'Счастливое',
  'Табачное',
  'Танковое',
  'Тенистое',
  'Тополи',
  'Трудолюбовка',
  'Тургеневка',
  'Угловое',
  'Фурмановка',
  'Ходжа-Сала',
  'Холмовка',
  'Шевченково',
  'Александровка',
  'Алексеевка',
  'Анновка',
  'Ароматное',
  'Баланово',
  'Балки',
  'Барабаново',
  'Белая Скала',
  'Белогорск',
  'Богатое',
  'Васильевка',
  'Верхние Орешники',
  'Вишенное',
  'Вишнёвое',
  'Владимировка',
  'Головановка',
  'Горлинка',
  'Дивное',
  'Дозорное',
  'Долиновка',
  'Еленовка',
  'Зеленогорское',
  'Земляничное',
  'Зуя',
  'Зыбины',
  'Карасёвка',
  'Кизиловка',
  'Кирпичное',
  'Красная Слобода',
  'Красногорское',
  'Красносёловка',
  'Кривцово',
  'Криничное',
  'Крымская Роза',
  'Курортное',
  'Курское',
  'Лечебное',
  'Литвиненково',
  'Луговое',
  'Малиновка',
  'Межгорье',
  'Мелехово',
  'Мельники',
  'Мельничное',
  'Мироновка',
  'Мичуринское',
  'Муромское',
  'Некрасово',
  'Нижние Орешники',
  'Новоалександровка',
  'Новогригорьевка',
  'Новожиловка',
  'Новоклёново',
  'Овражки',
  'Опытное',
  'Павловка',
  'Пасечное',
  'Петрово',
  'Поворотное',
  'Пролом',
  'Пчелиное',
  'Радостное',
  'Родники',
  'Русаковка',
  'Русское',
  'Северное',
  'Сенное',
  'Синекаменка',
  'Тополевка',
  'Тургенево',
  'Ударное',
  'Украинка',
  'Ульяновка',
  'Учебное',
  'Черемисовка',
  'Хлебное',
  'Цветочное',
  'Чернополье',
  'Яблочное',
  'Яковлевка',
  'Азовское',
  'Антоновка',
  'Апрелевка',
  'Арбузовка',
  'Армейское',
  'Благодатное',
  'Ближнегородское',
  'Ближнее',
  'Болотное',
  'Бородино',
  'Весёлое',
  'Ветвистое',
  'Володино',
  'Вольное',
  'Выпасное',
  'Дмитриевка',
  'Днепровка',
  'Дорожное',
  'Дубровка',
  'Ермаково',
  'Жилино',
  'Завет-Ленинский',
  'Заречное',
  'Зелёный Яр',
  'Зерновое',
  'Изумрудное',
  'Источное',
  'Калиновка',
  'Ковыльное',
  'Колоски',
  'Комсомольское',
  'Кондратьево',
  'Константиновка',
  'Копани',
  'Краснодольное',
  'Крымка',
  'Ларино',
  'Лобаново',
  'Луганское',
  'Майское',
  'Мартыновка',
  'Марьино',
  'Маслово',
  'Медведевка',
  'Мелководное',
  'Мирновка',
  'Митюрино',
  'Мичуриновка',
  'Многоводное',
  'Мысовое',
  'Находка',
  'Нижние Отрожки',
  'Низинное',
  'Новая Жизнь',
  'Новоконстантиновка',
  'Новокрымское',
  'Новопавловка',
  'Новосельцево',
  'Новостепное',
  'Новофёдоровка',
  'Овощное',
  'Озерки',
  'Озёрное',
  'Октябрь',
  'Орденоносное',
  'Островское',
  'Отрадное',
  'Павловка',
  'Пахаревка',
  'Перепёлкино',
  'Победное',
  'Полевое',
  'Предмостное',
  'Придорожное',
  'Пробуждение',
  'Прозрачное',
  'Просторное',
  'Пушкино',
  'Родное',
  'Роскошное',
  'Рощино',
  'Рубиновка',
  'Рысаково',
  'Рюмшино',
  'Светлое',
  'Серноводское',
  'Славянка',
  'Славянское',
  'Смежное',
  'Советское',
  'Солёное Озеро',
  'Солонцовое',
  'Стальное',
  'Стефановка',
  'Столбовое',
  'Субботник',
  'Табачное',
  'Тарасовка',
  'Тимирязево',
  'Тимофеевка',
  'Томашевка',
  'Тургенево',
  'Тутовое',
  'Ударное',
  'Фёдоровка',
  'Хлебное',
  'Целинное',
  'Чайкино',
  'Яркое',
  'Яркое Поле',
  'Ясное',
  'Яснополянское',
  'Ястребцы',
  'Абрикосовка',
  'Айвазовское',
  'Бабенково',
  'Васильковое',
  'Видное',
  'Владиславовка',
  'Возрождение',
  'Добролюбовка',
  'Долинное',
  'Жемчужина Крыма',
  'Журавки',
  'Золотое Поле',
  'Изобильное',
  'Изюмовка',
  'Кировское',
  'Ключевое',
  'Красновка',
  'Красносельское',
  'Кринички',
  'Льговское',
  'Маковское',
  'Матросовка',
  'Новопокровка',
  'Новофёдоровка',
  'Ореховка',
  'Отважное',
  'Партизаны',
  'Первомайское',
  'Приветное',
  'Пруды',
  'Садовое',
  'Синицыно',
  'Софиевка',
  'Спасовка',
  'Старый Крым',
  'Токарево',
  'Трудолюбовка',
  'Тутовка',
  'Шубино',
  'Яркое Поле',
  'Азов',
  'Александровка',
  'Амурское',
  'Ближнее',
  'Видное',
  'Вишняковка',
  'Владимирово',
  'Восход',
  'Григорьевка',
  'Докучаево',
  'Доходное',
  'Дубровское',
  'Заречное',
  'Заря',
  'Звёздное',
  'Зерновое',
  'Знаменка',
  'Золотое',
  'Известковое',
  'Искра',
  'Калинино',
  'Карповка',
  'Клепинино',
  'Климово',
  'Колодезное',
  'Комаровка',
  'Коммунары',
  'Котельниково',
  'Красная Долина',
  'Красная Поляна',
  'Красногвардейское',
  'Краснодарка',
  'Краснознаменка',
  'Красный Партизан',
  'Кремневка',
  'Курганное',
  'Ленинское',
  'Марьяновка',
  'Машино',
  'Менделеево',
  'Миролюбовка',
  'Мироновка',
  'Молочное',
  'Мускатное',
  'Найдёновка',
  'Нахимово',
  'Невское',
  'Некрасово',
  'Новоалексеевка',
  'Новодолинка',
  'Новоекатериновка',
  'Новозуевка',
  'Новоивановка',
  'Новоникольское',
  'Новопокровка',
  'Новосельцы',
  'Новоэстония',
  'Октябрьское',
  'Орловка',
  'Петровка',
  'Плодородное',
  'Победино',
  'Пологи',
  'Полтавка',
  'Проточное',
  'Прямое',
  'Пушкино',
  'Пятихатка',
  'Радужное',
  'Ровное',
  'Рогово',
  'Салгирка',
  'Симоненко',
  'Тимашовка',
  'Тимошенко',
  'Трактовое',
  'Удачное',
  'Ульяновка',
  'Холмовое',
  'Цветково',
  'Чапаево',
  'Щербаково',
  'Янтарное',
  'Ястребовка',
  'Богачёвка',
  'Братское',
  'Вишнёвка',
  'Воинка',
  'Воронцовка',
  'Долинка',
  'Зелёная Нива',
  'Знаменка',
  'Ильинка',
  'Источное',
  'Ишунь',
  'Карпова Балка',
  'Красноармейское',
  'Крепкое',
  'Курганное',
  'Магазинка',
  'Надеждино',
  'Новоалександровка',
  'Новоивановка',
  'Новониколаевка',
  'Новопавловка',
  'Новорыбацкое',
  'Орловское',
  'Полтавское',
  'Почётное',
  'Привольное',
  'Пролетарка',
  'Пятихатка',
  'Рисовое',
  'Сватово',
  'Смушкино',
  'Совхозное',
  'Таврическое',
  'Танковое',
  'Трактовое',
  'Уткино',
  'Филатовка',
  'Шатры',
  'Азовское',
  'Багерово',
  'Батальное',
  'Белинское',
  'Бондаренково',
  'Борисовка',
  'Верхнезаморское',
  'Виноградное',
  'Войково',
  'Вулкановка',
  'Вязниково',
  'Глазовка',
  'Горностаевка',
  'Егорово',
  'Ерофеево',
  'Заветное',
  'Заводское',
  'Затишное',
  'Зелёный Яр',
  'Золотое',
  'Ивановка',
  'Ильичёво',
  'Калиновка',
  'Каменское',
  'Кирово',
  'Королёво',
  'Костырино',
  'Красногорка',
  'Курортное',
  'Ленино',
  'Ленинское',
  'Либкнехтовка',
  'Луговое',
  'Львово',
  'Марфовка',
  'Марьевка',
  'Мысовое',
  'Набережное',
  'Нижнезаморское',
  'Новониколаевка',
  'Новоотрадное',
  'Новосёловка',
  'Огоньки',
  'Октябрьское',
  'Осовины',
  'Останино',
  'Песочное',
  'Петрово',
  'Приозёрное',
  'Прудниково',
  'Пташкино',
  'Романово',
  'Семёновка',
  'Семисотка',
  'Соляное',
  'Станционное',
  'Тасуново',
  'Уварово',
  'Фонтан',
  'Фронтовое',
  'Челядиново',
  'Чистополье',
  'Щёлкино',
  'Южное',
  'Юркино',
  'Яковенково',
  'Яркое',
  'Ячменное',
  'Акимовка',
  'Буревестник',
  'Великоселье',
  'Владиславовка',
  'Дворовое',
  'Двуречье',
  'Дрофино',
  'Емельяновка',
  'Желябовка',
  'Жемчужина',
  'Заливное',
  'Заречье',
  'Зелёное',
  'Зоркино',
  'Ивановка',
  'Изобильное',
  'Кирсановка',
  'Коврово',
  'Коренное',
  'Косточковка',
  'Кукурузное',
  'Кунцево',
  'Линейное',
  'Лиственное',
  'Ломоносово',
  'Луговое',
  'Лужки',
  'Любимовка',
  'Межевое',
  'Митрофановка',
  'Михайловка',
  'Нежинское',
  'Нижнегорский',
  'Новогригорьевка',
  'Новоивановка',
  'Охотское',
  'Пены',
  'Плодовое',
  'Приречное',
  'Пшеничное',
  'Разливы',
  'Родники',
  'Садовое',
  'Семенное',
  'Серово',
  'Сливянка',
  'Степановка',
  'Стрепетово',
  'Тамбовка',
  'Тарасовка',
  'Уваровка',
  'Уютное',
  'Фрунзе',
  'Цветущее',
  'Червоное',
  'Чкалово',
  'Широкое',
  'Ястребки',
  'Абрикосово',
  'Алексеевка',
  'Арбузово',
  'Братское',
  'Войково',
  'Выпасное',
  'Гвардейское',
  'Гришино',
  'Дальнее',
  'Дмитровка',
  'Еленовка',
  'Калинино',
  'Каменка',
  'Каштановка',
  'Кормовое',
  'Крестьяновка',
  'Крыловка',
  'Левитановка',
  'Макаровка',
  'Матвеевка',
  'Мельничное',
  'Новая Деревня',
  'Октябрьское',
  'Островское',
  'Открытое',
  'Панфиловка',
  'Первомайское',
  'Правда',
  'Привольное',
  'Пшеничное',
  'Ровное',
  'Сары-Баш',
  'Свердловское',
  'Снегирёвка',
  'Стахановка',
  'Степное',
  'Сусанино',
  'Тихоновка',
  'Упорное',
  'Фрунзе',
  'Чапаево',
  'Черново',
  'Аврора',
  'Бахчёвка',
  'Берёзовка',
  'Ботаническое',
  'Ветрянка',
  'Волочаевка',
  'Воронки',
  'Зимино',
  'Камышное',
  'Каштановка',
  'Ковыльное',
  'Коммунарное',
  'Котовское',
  'Красноармейское',
  'Кропоткино',
  'Кукушкино',
  'Кумово',
  'Максимовка',
  'Молочное',
  'Нива',
  'Новосёловское',
  'Овражное',
  'Огни',
  'Огородное',
  'Орловка',
  'Портовое',
  'Раздольное',
  'Ручьи',
  'Рылеевка',
  'Северное',
  'Сенокосное',
  'Серебрянка',
  'Славное',
  'Славянское',
  'Соколы',
  'Стерегущее',
  'Ульяновка',
  'Фёдоровка',
  'Червоное',
  'Чернышёво',
  'Чехово',
  'Абрикосовка',
  'Валентиново',
  'Великое',
  'Вересаево',
  'Вершинное',
  'Весёловка',
  'Ветровка',
  'Виноградово',
  'Витино',
  'Владимировка',
  'Властное',
  'Водопойное',
  'Воробьёво',
  'Гаршино',
  'Геройское',
  'Глинка',
  'Громовка',
  'Добрушино',
  'Долинка',
  'Елизаветово',
  'Жаворонки',
  'Желтокаменка',
  'Журавли',
  'Зерновое',
  'Ивановка',
  'Игоревка',
  'Известковое',
  'Ильинка',
  'Каменоломня',
  'Карьерное',
  'Колоски',
  'Кольцово',
  'Крайнее',
  'Крыловка',
  'Крымское',
  'Куликовка',
  'Лесновка',
  'Лиманное',
  'Листовое',
  'Луговое',
  'Лушино',
  'Митяево',
  'Михайловка',
  'Молочное',
  'Наташино',
  'Наумовка',
  'Нива',
  'Низинное',
  'Новофёдоровка',
  'Огневое',
  'Орехово',
  'Орлянка',
  'Охотниково',
  'Победное',
  'Поповка',
  'Порфирьевка',
  'Прибрежное',
  'Приветное',
  'Ромашкино',
  'Рунное',
  'Сизовка',
  'Солдатское',
  'Степное',
  'Столбовое',
  'Суворовское',
  'Трудовое',
  'Туннельное',
  'Уютное',
  'Фрунзе',
  'Фурманово',
  'Хуторок',
  'Чеботарка',
  'Червоное',
  'Шалаши',
  'Шаумян',
  'Шелковичное',
  'Шишкино',
  'Штормовое',
  'Яркое',
  'Айкаван',
  'Акрополис',
  'Александровка',
  'Ана-Юрт',
  'Андрусово',
  'Аркадьевка',
  'Белоглинка',
  'Верхнекурганное',
  'Весёлое',
  'Винницкое',
  'Водное',
  'Гвардейское',
  'Грушевое',
  'Давыдово',
  'Демьяновка',
  'Денисовка',
  'Дивное',
  'Дмитрово',
  'Доброе',
  'Донское',
  'Дружное',
  'Дубки',
  'Живописное',
  'Журавлёвка',
  'Залесье',
  'Заречное',
  'Ивановка',
  'Камышинка',
  'Каштановое',
  'Кизиловое',
  'Клёновка',
  'Клиновка',
  'Ключевое',
  'Ключи',
  'Колодезное',
  'Кольчугино',
  'Константиновка',
  'Красная Зорька',
  'Красновка',
  'Красное',
  'Краснолесье',
  'Кубанское',
  'Куприно',
  'Курганное',
  'Лазаревка',
  'Левадки',
  'Лекарственное',
  'Лесноселье',
  'Лозовое',
  'Мазанка',
  'Маленькое',
  'Межгорное',
  'Мирное',
  'Молодёжное',
  'Молочное',
  'Мраморное',
  'Нижнекурганное',
  'Николаевка',
  'Новоандреевка',
  'Новозбурьевка',
  'Новониколаевка',
  'Новосёловка',
  'Новый Мир',
  'Новый Сад',
  'Обрыв',
  'Опушки',
  'Партизанское',
  'Первомайское',
  'Перевальное',
  'Передовое',
  'Перово',
  'Петровка',
  'Петропавловка',
  'Пионерское',
  'Пожарское',
  'Привольное',
  'Пролётное',
  'Прудовое',
  'Равнополье',
  'Раздолье',
  'Родниково',
  'Скворцово',
  'Совхозное',
  'Солнечное',
  'Соловьёвка',
  'Софиевка',
  'Спокойное',
  'Сторожевое',
  'Строгоновка',
  'Сумское',
  'Сухоречье',
  'Тепловка',
  'Тёплое',
  'Топольное',
  'Трёхпрудное',
  'Трудовое',
  'Трудолюбово',
  'Украинка',
  'Укромное',
  'Урожайное',
  'Ферсманово',
  'Фонтаны',
  'Харитоновка',
  'Чайкино',
  'Чайковское',
  'Чистенькое',
  'Шафранное',
  'Широкое',
  'Школьное',
  'Алмазное',
  'Варваровка',
  'Восточное',
  'Георгиевка',
  'Демьяновка',
  'Дмитровка',
  'Дятловка',
  'Заветное',
  'Ильичёво',
  'Коломенское',
  'Корнеевка',
  'Красногвардейское',
  'Краснофлотское',
  'Лебединка',
  'Лоховка',
  'Лучевое',
  'Маковка',
  'Марково',
  'Надежда',
  'Некрасовка',
  'Николаевка',
  'Новосёловка',
  'Новый Мир',
  'Октябрьское',
  'Привольное',
  'Присивашное',
  'Пруды',
  'Пушкино',
  'Пчельники',
  'Раздольное',
  'Речное',
  'Ровенка',
  'Советский',
  'Урожайное',
  'Хлебное',
  'Чапаевка',
  'Чернозёмное',
  'Шахтино',
  'Артёмовка',
  'Владимировка',
  'Внуково',
  'Водопойное',
  'Громово',
  'Далёкое',
  'Дозорное',
  'Журавлёвка',
  'Задорное',
  'Зайцево',
  'Знаменское',
  'Зоряное',
  'Калиновка',
  'Кировское',
  'Красная Поляна',
  'Красносельское',
  'Красноярское',
  'Кузнецкое',
  'Ленское',
  'Марьино',
  'Маяк',
  'Медведево',
  'Межводное',
  'Низовка',
  'Новоивановка',
  'Новосельское',
  'Новоульяновка',
  'Озёровка',
  'Окунёвка',
  'Оленевка',
  'Северное',
  'Снежное',
  'Хмелево',
  'Черноморское',
  'Севастополь',
  'Балаклава',
  'Гончарное',
  'Инкерман',
  'Кизиловое',
  'Колхозное',
  'Ласпи',
  'Морозовка',
  'Новобобровское',
  'Оборонное',
  'Озёрное',
  'Орлиное',
  'Павловка',
  'Первомайское',
  'Передовое',
  'Подгорное',
  'Резервное',
  'Родниковое',
  'Родное',
  'Россошанка',
  'Сахарная Головка',
  'Терновка',
  'Тыловое',
  'Ушаковка',
  'Ушаково',
  'Флотское',
  'Хмельницкое',
  'Черноречье',
  'Широкое',
  'Штурмовое',
  'Андреевка',
  'Верхнесадовое',
  'Вишнёвое',
  'Кача',
  'Дальнее',
  'Камышлы',
  'Орловка',
  'Осипенко',
  'Пироговка',
  'Поворотное',
  'Полюшко',
  'Солнечный',
  'Фронтовое',
  'Фруктовое',
]
